import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { TaskList } from '../components/tasks/TaskList';

export const TasksPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get('taskId');

  return (
    <div className="container mx-auto py-10">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-foreground">Task Management</h1>
      </div>
      <TaskList initialTaskId={taskId} />
    </div>
  );
}; 